export const TOKEN_SET = 'TOKEN_SET';
export const TOKEN_UNSET = 'TOKEN_UNSET';
export const LOGIN_REQUESTING = 'LOGIN_REQUESTING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_EXISTING = 'LOGIN_EXISTING';
export const LOGOUT = 'LOGOUT';
export const SET_AUTHORIZATION_HEADER = 'SET_AUTHORIZATION_HEADER';
export const SET_USER_INFO = 'SET_USER_INFO';
